import { syncedBalancesAtomDefinition } from './atoms/index.js'
import syncedBalancedModuleDefinition from './module/index.js'
import syncedBalancesPluginDefinition from './plugin/index.js'
import ms from 'ms'

const DEFAULT_THROTTLE_PUSH_MS = ms('1hr')

const syncedBalances = ({ throttlePushMs = DEFAULT_THROTTLE_PUSH_MS } = Object.create(null)) => ({
  id: 'syncedBalances',
  definitions: [
    {
      definition: syncedBalancedModuleDefinition,
      config: {
        throttlePushMs,
      },
    },
    {
      definition: syncedBalancesAtomDefinition,
    },
    {
      definition: syncedBalancesPluginDefinition,
    },
  ],
})

export default syncedBalances
